<template>
    <form id="mainForm" action="#" method="post">
      <Card>
          <template #title>
              <Toolbar>
              <template #left>
                  <div class="p-card-title">STO Report</div>
              </template>
              </Toolbar>
          </template>
          <template #content>
              <div class="p-inputtext-sm p-fluid">
                  <div class="grid">
                    <div class="col-12 field grid" style="padding: 0 0.5rem 0 0.5rem">
                          <label class="col-2">{{ $t("created_date") }}</label>
                          <DatePicker  dateFormat="dd/mm/yy"  v-model="header.Created_Date_From" class="col-4" />
                          <label class="col-1">To</label>
                          <DatePicker dateFormat="dd/mm/yy" v-model="header.Created_Date_To" class="col-4" />
                      </div>
                      <div class="col-12 field grid" style="padding: 0 0.5rem 0 0.5rem">
                          <label class="col-2">{{ $t("doc_date") }}</label>
                          <DatePicker  dateFormat="dd/mm/yy"  v-model="header.Document_Date_From" class="col-4" />
                          <label class="col-1">To</label>
                          <DatePicker dateFormat="dd/mm/yy" v-model="header.Document_Date_To" class="col-4" />
                      </div>
                      <div class="col-12">
                          <FormField fieldName="Filter_By" :labelName="$t('filter_by')" v-model="header" fieldClass="col-6" labelClass="col-2">
                              <CustomMultiSelect
                                  v-model="header.Filter_By"
                                  class="p-inputtext-sm"
                                  :url="this.$API_URL + 'list/lookup'"
                                  :params="{ group: this.$LOOKUP_GROUP.STO_FILTER_BY }"
                              />
                          </FormField>
                          <FormField fieldName="STO_No" :labelName="$t('sto_no')" v-model="header" fieldClass="col-6" labelClass="col-2">
                              <!-- <InputText
                                  name="STO_No"
                                  type="text"
                                  class="p-inputtext-sm"
                                  v-model="header.Document_No"
                                  :placeholder="$t('sto_no')"
                              /> -->

                              <CustomChips v-model="header.Document_No" :allowDuplicate="false" :inputSeparator="' '" :separator="' '"/>
                          </FormField>
                          <FormField fieldName="PurchaseOrganizationList" :labelName="$t('purchase_org')" v-model="header" fieldClass="col-6" labelClass="col-2">
                              <CustomMultiSelect 
                                  v-model="header.PurchaseOrganizationList" 
                                  :url="this.$API_URL + 'list/purchase_organization'"
                                  :params="{}" />
                          </FormField>
                          <FormField fieldName="Loading_Destination_From_Id" :labelName="$t('loading')" v-model="header" fieldClass="col-6" labelClass="col-2" >
                              <CustomMultiSelect
                                  v-model="header.Loading"
                                  class="p-inputtext-sm"
                                  :url="this.$API_URL + 'list/location_code'"
                                  :minLength="0"
                                  :params="{}"
                                  :filter="true"
                                  optionValue="nama"
                                  />
                          </FormField>
                          <FormField fieldName="Loading_Destination_To_Id" :labelName="$t('destination')" v-model="header" fieldClass="col-6" labelClass="col-2" >
                              <CustomMultiSelect
                                  v-model="header.Destination"
                                  class="p-inputtext-sm"
                                  :url="this.$API_URL + 'list/location_code'"
                                  :minLength="0"
                                  :params="{}"
                                  :filter="true"
                                  optionValue="nama"
                                  />
                          </FormField>
                          <FormField fieldName="Shipment_Type" :labelName="$t('shipment_type')" v-model="header" fieldClass="col-6" labelClass="col-2">
                              <CustomMultiSelect
                                  v-model="header.ShipmentTypeList"
                                  class="p-inputtext-sm"
                                  :url="this.$API_URL + 'list/lookup'"
                                  :params="{ group: this.$LOOKUP_GROUP.SHIPMENT_TYPE }"
                              />
                          </FormField>
                          <FormField fieldName="Order_Type" labelName="Order Type" v-model="header" fieldClass="col-6" labelClass="col-2" >
                              <CustomMultiSelect
                                  class="p-inputtext-sm"
                                  v-model="header.OrderTypeList"
                                  :url="this.$API_URL + 'list/order_type_code'"
                                  :minLength="0"
                                  :params="{}"
                                  :filter="true"
                              />
                          </FormField>
                          <FormField fieldName="Transporter_Code" :labelName="$t('transporter')" v-model="header" fieldClass="col-6" labelClass="col-2">
                              <CustomMultiSelect v-model="header.TransporterList" :url="this.$API_URL + 'list/transporter_all'" :params="{}" />
                          </FormField>
                          <FormField fieldName="CompanyList" :labelName="$t('company')" v-model="header" fieldClass="col-6" labelClass="col-2">
                              <CustomMultiSelect v-model="header.CompanyList" 
                                  :url="this.$API_URL + 'list/company_code'" :params="{}" />
                          </FormField>
                          <FormField fieldName="PlantList" :labelName="$t('plant_supplying')" v-model="header" fieldClass="col-6" labelClass="col-2">
                              <CustomMultiSelect v-model="header.PlantList" 
                                  :url="this.$API_URL + 'list/plant'" :params="{}" />
                          </FormField>
                          <FormField fieldName="ProductCategoryList" :labelName="$t('product_category')" v-model="header" fieldClass="col-6" labelClass="col-2">
                              <CustomMultiSelect v-model="header.ProductCategoryList" 
                                  :url="this.$API_URL + 'list/business_segment_code'" :params="{}" />
                          </FormField>
                          <FormField fieldName="PlantList" :labelName="$t('commodity')" v-model="header" fieldClass="col-6" labelClass="col-2">
                              <CustomMultiSelect v-model="header.CommodityList" 
                                  :url="this.$API_URL + 'list/commodity_group'" :params="{}" />
                          </FormField>
                          <FormField fieldName="Without_Price" :labelName="$t('without_price')" v-model="header" fieldClass="col-6" labelClass="col-2">
                              <YNSelect :placeholder="$t('without_price')" :useBinary="false" v-if="header" v-model="header.Without_Price" />
                          </FormField>
                      </div>
                  </div>
              </div>
              <Button type="button" label="Generate" @click="getReport()" />
              &nbsp;
              <Button
                  type="button"
                  class="p-button-success"
                  label="Reopen"
                  @click="reopenTab()"
                  v-show="this.reportTbl"
                  />
          </template>
      </Card>
    </form>
  
      <ShowReport
          :title="title"
          :isVisible="showReport"
          :reportTbl="this.reportTbl"
          @close="resetBtn()"
      />
  </template>
  
  <script type="text/javascript">
  import ShowReport from "../Report/ShowReport.vue";
  import FormField from "../Helper/FormField.vue";
  export default {
      components: {
          ShowReport,
          FormField,
      },
      data() {
          name: "STOReport";
          return {
              test: 0,
              mode: "",
              url: this.$API_URL + "report/",
              reportTbl: null,
              showReport: false,
              loadingReport: false,
              withoutPriceOptions: [
                  { label: "Y", value: "Y" },
                  { label: "N", value: "N" },
              ],
              header: {
                  Filter_By: null,
                  Document_No: null,
                  Document_Date_From: null,
                  Document_Date_To: null,
                  PurchaseOrganizationList:null,
                  Loading:null,
                  Destination: null,
                  ShipmentTypeList:null,
                  OrderTypeList:null,
                  TransporterList: null,
                  CompanyList: null,
                  PlantList:null,
                  ProductCategoryList:null,
                  CommodityList:null,
                  Without_Price: null
              },
          };
      },
      methods: {
          reopenTab() {
              this.showReport = true;
          },
          resetBtn() {
              this.showReport = false;
          },
          tableToExcel() {
              this.loadingReport = !this.loadingReport;
          },
          getReport() {
              // this.visibleBar = true;
              // this.loadingReport = !this.loadingReport;
              this.$emit("blockBody");
              this.$axios
                  .post(this.url + "generate_sto_report", this.header)
                  .then((response) => {
                  this.reportTbl = {
                      header: response.data.data.header,
                      content: response.data.data.content,
                      title: response.data.data.title,
                  };
                  // this.showError(response);
                  this.showReport = true;
                  this.$emit("unblockBody");
                  })
                  .catch((exc) => {
                  // this.showError(response);
                  // console.log(1);
                  this.$emit("unblockBody");
                  });
              },
          showError(msg) {
              this.loadingReport = !this.loadingReport;
          },
          closeReport() {
              this.showReport=false;
          },
      },
      mounted() {},
  };
  </script>
  